import * as types from "../constants";

const initialState = {
  isAuthenticated: false,
  authToken: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.AUTH_SET_TOKEN:
      return {
        ...state,
        authToken: action.authToken,
        isAuthenticated: true,
      };
    case types.AUTH_DEL_TOKEN:
      return {
        ...state,
        authToken: null,
        isAuthenticated: false,
      };
    default:
      return state;
  }
}
